
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function PageHeader(props) {
    const patternInput = useTranslation();
    return reactElement("div", {
        className: join(" ", ["font-ubuntu", "font-bold", "text-4xl", "text-black", "mb-4"]),
        children: patternInput[0](props.Text),
    });
}

export function SectionHeader(props) {
    const patternInput = useTranslation();
    return reactElement("div", {
        className: join(" ", ["font-bold", "text-2xl", "text-black", "mb-4"]),
        children: patternInput[0](props.Text),
    });
}

export function BlockHeader(props) {
    const patternInput = useTranslation();
    return reactElement("div", {
        className: join(" ", ["font-bold", "text-sm", "text-black", "mb-4"]),
        children: patternInput[0](props.Text),
    });
}

export function BoxHeader(props) {
    const patternInput = useTranslation();
    return reactElement("div", {
        className: join(" ", ["font-bold", "text-xl", "text-black", "mb-4"]),
        children: patternInput[0](props.Text),
    });
}

export function TextValue(props) {
    return reactElement("div", {
        className: join(" ", toList(delay(() => {
            let matchValue;
            return append((matchValue = props.FontWeight, (matchValue === "semiBold") ? singleton("font-semibold") : ((matchValue === "normal") ? singleton("font-normal") : ((matchValue === "small") ? singleton("text-sm") : singleton("font-bold")))), delay(() => append(singleton("text-sm"), delay(() => append(singleton("text-black"), delay(() => singleton("whitespace-pre-wrap")))))));
        }))),
        children: props.Text,
        "data-test-id": props.TestId,
    });
}

export function SmallTextValue(props) {
    return reactElement("div", {
        className: join(" ", toList(delay(() => {
            let matchValue;
            return append((matchValue = props.FontWeight, (matchValue === "semiBold") ? singleton("font-semibold") : ((matchValue === "normal") ? singleton("font-normal") : ((matchValue === "small") ? singleton("font-light") : singleton("font-bold")))), delay(() => append(singleton("text-xs"), delay(() => append(singleton("text-black"), delay(() => singleton("whitespace-pre-wrap")))))));
        }))),
        children: props.Text,
        "data-test-id": props.TestId,
    });
}

export function LabeledValue(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3"])], (elems = [reactElement("div", {
        className: join(" ", ["font-bold", "mb-1"]),
        children: props.Label,
    }), reactElement("div", {
        className: join(" ", ["text-lg", "min-h-[28px]"]),
        children: props.Value,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function LabeledInlineValue(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-2", "text-sm"])], (elems = [reactElement("span", {
        className: join(" ", ["w-40", "shrink-0", "text-gray-500"]),
        children: props.Label,
    }), reactElement("span", {
        className: join(" ", ["font-semibold"]),
        "data-test-id": props.TestId,
        children: props.Value,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function LabeledClickableValue(props) {
    let elems_2, elems_1, elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3"])], (elems_2 = [reactElement("div", {
        className: join(" ", ["font-bold", "mb-1"]),
        children: props.Label,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["text-lg", "min-h-[28px]"])], (elems_1 = [reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => ((props.ComponentState === "disabled") ? singleton("cursor-default") : singleton("cursor-pointer")))))))))], ["onClick", (props.ComponentState === "disabled") ? ((value_8) => {
    }) : ((_arg) => {
        props.OnClick();
    })], (elems = [reactElement("div", {
        className: join(" ", toList(delay(() => append((props.ComponentState === "enabled") ? singleton("text-primary-link") : singleton("text-text-muted"), delay(() => append(singleton("font-medium"), delay(() => append(singleton("flex"), delay(() => singleton("items-center")))))))))),
        children: props.Value,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function ModalTitle(props) {
    const patternInput = useTranslation();
    return reactElement("div", {
        className: join(" ", ["font-bold", "text-lg", "text-black", "flex-1", "truncate"]),
        children: patternInput[0](props.Text),
    });
}

export function InvalidTextValue(props) {
    return reactElement("div", {
        "data-test-id": props.TestId,
        className: join(" ", ["text-red", "text-sm"]),
        children: props.Text,
    });
}

